
export const START_WORDSEARCH_GAME_COMPLETED = "wordSearch/startGameCompleted";
export const GET_WORDSEARCH_GAME_COMPLETED = "wordSearch/getGameCompleted";
export const VALIDATE_WORD_COMPLETED = "wordSearch/validateWordCompleted";
export const SUBMIT_WORDSEARCH_SOLUTION_COMPLETED = "wordSearch/submitSolutionCompleted";
export const ADD_FOUND_WORD = "wordSearch/addFoundWord";
export const REVEAL_WORDS_COMPLETED = "wordSearch/revealWordsCompleted";